<!-- 找商机-发布需求 -->
<template>
  <div class="bl-container">
    <div class="release-view">
      <div class="op-section">
        <h3 class='m-b-12'>{{$t('releaseTips')}}</h3>
        <p>
          <strong>{{ $t('requirement_content') }}</strong
          >：
        </p>
        <el-input class="op-textarea" type="textarea" :rows="5" :placeholder="$t('Please type something...')" v-model="content"> </el-input>
      </div>

      <div class="op-section">
        <p>
          <strong>{{ $t('upload_pictures_or_videos') }}</strong
          ><span>（{{ $t('upload_desc') }}）</span>
        </p>
        <div class="txt-notice">
          <div><i class="el-icon-warning"></i> {{ $t('Notice') }}</div>
          <div class="tips">
            {{ $t('uploadTips_1') }}<br />
            {{ $t('uploadTips_2') }}<br />
            {{ $t('uploadTips_3') }}<br />
            <template v-if="uploadFileStatus == 0">
            4.{{$t('productRangeTip2[0]')}}{{imgList.length}}{{$t('productRangeTip2[1]')}}{{9-imgList.length}}{{$t('productRangeTip2[2]')}}
            </template>
          </div>
        </div>

        <div class="button-group">
          <el-button
            :type="uploadFileStatus == 0 ? 'primary' : ''"
            size="mini"
            icon="el-icon-circle-plus-outline"
            :disabled="imgList.length >= 9"
            @click="uploadFile('uploadImg', 0)"
            >{{ $t('Upload picture') }}</el-button
          >
          <el-button
            :type="uploadFileStatus == 1 ? 'primary' : ''"
            size="mini"
            icon="el-icon-circle-plus-outline"
            @click="uploadFile('uploadVideo', 1)"
            >{{ $t('Upload video') }}</el-button
          >
          <el-button
            :type="uploadFileStatus == 2 ? 'primary' : ''"
            size="mini"
            icon="el-icon-circle-plus-outline"
            @click="uploadFile('uploadPreviewImage', 2)"
            >{{ $t('finds.uploadVideoImg') }}</el-button
          >
        </div>
        <div class="upload-image-container">
          <DashUploadMore ref="uploadImg" v-show="uploadFileStatus === 0" :uploadBtn="false" :mediaUrl.sync="imgList" />

          <DashUploadMore
            ref="uploadVideo"
            v-show="uploadFileStatus === 1"
            :limit="1"
            :media="'video'"
            :uploadBtn="false"
            :mediaUrl.sync="videoUrl"
          />

          <DashUploadMore
            ref="uploadPreviewImage"
            v-show="uploadFileStatus === 2"
            :limit="1"
            :uploadBtn="false"
            :mediaUrl.sync="previewImageUrl"
          />
        </div>
      </div>

      <div class="op-section">
        <div class="title-section">
          <strong>{{ $t('receiving_object') }}</strong
          >：<span class="receivingTips">({{ subjectType == 'ACTOR' ? $t('receiving_object_tips') : $t('receiving_object_tips2') }})</span>
        </div>
        <TagSelection ref="tag-selection" />
      </div>
    </div>

    <div class="text-center release-submit">
      <el-button class="dash-submit btn-544" type="primary" @click="submit" v-loading="submitLoading" :disabled="isDisabled">{{
        $t('Confirm and publish')
      }}</el-button>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { saveCommercialDistrict, isSendCommercialDistrict } from '@/api/opportunity'
import DashUploadMore from '@/components/DashUploadMore'
import TagSelection from '@/components/TagSelection'
export default {
  components: {
    DashUploadMore,
    TagSelection
  },
  data() {
    return {
      options: [],
      imgList: [],
      videoUrl: [], // 视频URL
      previewImageUrl: [], // 视频图片
      siteValue: [],
      content: '',
      questionList: [],
      submitLoading: false,
      isMultiple: true,
      uploadFileStatus: 0
    }
  },
  computed: {
    ...mapGetters(['subjectType']),

    isDisabled() {
      if (this.content !== '') {
        return false
      }
      return true
    }
  },
  mounted() {},
  methods: {
    submit() {
      if (!this.checkParams()) {
        return
      }
      var params = this.getParms()

      this.submitLoading = true
      isSendCommercialDistrict({})
        .then(res => {
          if (res.data.code == 1000 && res.data.data) {
            saveCommercialDistrict(params)
              .then(res => {
                return res.data
              })
              .then(res => {
                this.submitLoading = false
                if (res.code === 1000) {
                  window.PC.$RangersEventOpportunity(this.subjectType, 'send')
                  this.$notify({
                    title: this.$t('published_successfully'),
                    type: 'success'
                  })
                  this.$router.push('/opportunity-manage/list')
                }
              })
              .finally(() => {
                this.submitLoading = false
              })
          } else {
            this.$notify.error({
              message: this.$t("Your publisher's cycle count has reached its limit")
            })
          }
        })
        .finally(() => {
          this.submitLoading = false
        })
    },
    getParms() {
      var params = {
        actorList: [],
        videoUrl: this.videoUrl.length === 0 ? '' : this.videoUrl.join(''),
        imgUrl: this.getImgArr().join(','),
        previewImageUrl: this.previewImageUrl.length === 0 ? '' : this.previewImageUrl.join(''),
        operateSubjectType: this.$store.getters.subjectType,
        questionList: this.questionList,
        content: this.content
      }
      if (this.videoUrl.length === 0) {
        params['publishType'] = 'image'
      } else {
        params['publishType'] = 'video'
      }
      return params
    },
    checkParams() {
      this.questionList = this.$refs['tag-selection'].getQuestionList()
      // 展商标签改为 选填
      // if (this.questionList.length === 0) {
      //   this.$notify({
      //     title: this.$t('select_receiving_alter'),
      //     type: 'error'
      //   })
      //   return false
      // }
      if (this.content === '') {
        this.$notify({
          title: this.$t('requirement_content') + ' ' + this.$t('common.required'),
          type: 'error'
        })
        return false
      }
      return true
    },

    // 获取imgList（布局使用）
    getImgArr() {
      var imgList = JSON.parse(JSON.stringify(this.imgList))
      imgList = imgList.filter(d => {
        return d !== '' && d
      })
      return imgList
    },

    uploadFile(name, status) {
      if (status !== undefined) {
        this.uploadFileStatus = status

        if (status === 0) {
          this.videoUrl = []
          this.previewImageUrl = []
        } else {
          this.imgList = []
        }
      }

      if ((status === 1 && this.videoUrl.length == 1) || (status === 2 && this.previewImageUrl.length == 1)) {
        return
      }
      
      this.$refs[name].uploadAdd()
    }
  }
}
</script>

<style lang="stylus" scoped>
.bl-container
  padding 0
.release-view
  padding-top 30px
  .op-section
    padding 24px
    background $color-gray-fb
    width 100%
    margin-bottom 16px
    p
      font-size 16px
      font-family PingFangSC-Medium, PingFang SC
      font-weight 500
      color $color-black-65
      margin-bottom 24px
    .op-textarea
      width 740px
      padding-right 18px
    span
      font-size 14px
      font-family PingFangSC-Medium, PingFang SC
      font-weight 500
      color $color-black-45
  .txt-notice
    display flex
    color $color-main
    font-size 12px
    line-height 1.5
    margin-bottom 24px
    i
      color $color-orange-23
  .button-group,
  .title-section
    margin-bottom 24px

.release-submit
  padding-bottom 60px
  margin-top 30px
  .is-disabled
    background-color $color-black-25
    border none

.release-view .receivingTips
  margin 10px 0
  font-size 14px
  color $color-black-45
.upload-image-container
  width 740px
</style>
